import {Controller} from "stimulus";

export default class extends Controller
{
    static targets = ["input", "search", "table", "clear", "loading", "filteredNum",
        "download", "downloadIcon", "downloadLoading", "downloadDummy"
    ];

    TABLE_ROWS = [];
    
    connect()
    {
        let method = this.element.dataset["code"];

        this.TABLE_ROWS = Array.from(this.tableTarget.lastElementChild.cloneNode(true).children);

        this.searchTarget.addEventListener("click", e =>
        {

            if(!this.inputTarget.value && !this.clearTarget.classList.contains("hidden"))
            {
                this.searchTarget.classList.add("hidden");
                this.loadingTarget.classList.remove("hidden");

                this.tableTarget.lastElementChild.innerHTML = "";
                this.tableTarget.lastElementChild.append(...this.TABLE_ROWS);

                this.loadingTarget.classList.add("hidden");
                this.searchTarget.classList.remove("hidden");
                this.clearTarget.classList.add("hidden");

                this.filteredNumTarget.innerHTML = "";

                return;
            }

            if(!this.inputTarget.value) return;

            let query = this.inputTarget.value.split(" ");
            
            this.searchTarget.classList.add("hidden");
            this.loadingTarget.classList.remove("hidden");

            let filtered = this.TABLE_ROWS.filter(row =>
            {
                let text = row.textContent;
                return query.reduce((prev, curr) => prev && text.toLowerCase().includes(curr.toLowerCase()), true)
            });

            this.tableTarget.lastElementChild.innerHTML = "";
            this.tableTarget.lastElementChild.append(...filtered);

            this.loadingTarget.classList.add("hidden");
            this.searchTarget.classList.remove("hidden");
            this.clearTarget.classList.remove("hidden");

            this.filteredNumTarget.innerHTML = `(${filtered.length} filtered)`
        })

        this.clearTarget.addEventListener("click", e =>
        {
            this.inputTarget.value = "";
            this.filteredNumTarget.innerHTML = "";
            this.searchTarget.classList.add("hidden");
            this.loadingTarget.classList.remove("hidden");
            this.clearTarget.classList.add("hidden");

            this.tableTarget.lastElementChild.innerHTML = "";
            this.tableTarget.lastElementChild.append(...this.TABLE_ROWS);

            this.loadingTarget.classList.add("hidden");
            this.searchTarget.classList.remove("hidden");
        })

        this.downloadTarget.addEventListener("click", e =>
        {

            let form = this.tableTarget.closest(".tables")
                                 .parentElement.querySelector(".parameters form");
            let code = form.parentElement.dataset["code"];

            let parameters = new FormData(form);
            parameters.append("method", method);
            parameters.append("code", code);

            this.downloadIconTarget.classList.add("hidden");
            this.downloadLoadingTarget.classList.remove("hidden");

            fetch("/view-data/download",
            { 
                method: "POST",
                body: parameters
            })
            .then(res =>
            {
                if(!res.ok) throw new Error("An error occurred while generating the file.");
                return res.blob()
            })
            .then(blob =>
            {
                let obj = URL.createObjectURL(blob);
                this.downloadDummyTarget.href = obj;

                this.downloadDummyTarget.download = method + ".xlsx";

                this.downloadDummyTarget.click()
            })
            .catch(error =>
            {
                let event = new CustomEvent("show-toast", { detail: error.message });
                window.dispatchEvent(event);
            })
            .finally(() =>
            {
                this.downloadIconTarget.classList.remove("hidden");
                this.downloadLoadingTarget.classList.add("hidden");
            })
        })
    }
}